// src/components/Invoice/FinancialProjections.tsx
import React from 'react';

interface FinancialProjectionsProps {
  monthly: number;
  quarterly: number;
  annual: number;
  reliability: number;
}

const FinancialProjections: React.FC<FinancialProjectionsProps> = ({
  monthly,
  quarterly,
  annual,
  reliability
}) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div>
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Revenue Projections</h3>
      <div className="space-y-4">
        <div className="bg-white rounded-lg p-4 border border-gray-100">
          <div className="text-gray-500 mb-1">Monthly Average</div>
          <div className="text-xl font-bold text-gray-800">{formatCurrency(monthly)}</div>
        </div>
        
        <div className="bg-white rounded-lg p-4 border border-gray-100">
          <div className="text-gray-500 mb-1">Quarterly Projection</div>
          <div className="text-xl font-bold text-gray-800">{formatCurrency(quarterly)}</div>
        </div>
        
        <div className="bg-white rounded-lg p-4 border border-gray-100">
          <div className="text-gray-500 mb-1">Annual Projection</div>
          <div className="text-xl font-bold text-gray-800">{formatCurrency(annual)}</div>
        </div>
        
        <div className="bg-white rounded-lg p-4 border border-gray-100">
          <div className="text-gray-500 mb-1">Reliability Score</div>
          <div className="flex items-center">
            <div className="text-xl font-bold text-gray-800">{reliability}%</div>
            <div className="ml-2 w-24 h-2 bg-gray-200 rounded-full overflow-hidden">
              <div 
                className="h-full bg-medium-gray" 
                style={{ width: `${reliability}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialProjections;